const MODAL_PARAMS = ['selectedJobSlug', 'selectedCvSlug'] as const;

type ChatModalParam = (typeof MODAL_PARAMS)[number];

/**
 * Opens a job or CV detail as an in-place modal on the current chat page.
 *
 * `ChatJobModal` / `ChatTalentModal` watch the URL via `useUrlChange`, so flipping a query
 * param is what opens them — hence pushState rather than a router.push. Keeping the current
 * pathname means a refresh reloads the chat page with the modal open instead of the standalone
 * detail page. The hash is carried over so hash-based anchors/state on the page survive.
 * Opening one modal clears the other's param to keep them mutually exclusive.
 *
 * Shared by the markdown links in `ChatMessageComponent` and the talent cards in
 * `ChatMessageResults`, which must behave identically.
 */
export const openChatModalInPlace = (param: ChatModalParam, slug: string): void => {
  const params = new URLSearchParams(window.location.search);
  // The two modals gate on their own param and ignore the other, so a URL carrying both renders
  // them stacked. Keeping the params mutually exclusive is what prevents that.
  MODAL_PARAMS.filter((name) => name !== param).forEach((name) => params.delete(name));
  params.set(param, slug);
  window.history.pushState(null, '', `${window.location.pathname}?${params.toString()}${window.location.hash}`);
};
